<template>
    <div class="login">
       <div class="login-box">
          <p style="color:#262626;font-size: 36px;font-weight: bold;margin: 40px 0px 40px 0px;">OCT AI Labeling Tool</p>
          <div class="login-form" v-if="!loginStatus">
            <p style="color:#000000;font-size: 24px;font-weight: bold;margin: 20px 0px 20px 0px;">歡迎登入</p>
            <!-- <span style="color:#000000;font-size: 14px;margin: -10px 0px 20px 0px;">&nbsp;</span> -->
            <el-form
              label-position="right"
              label-width="100px"
              :model="login"
              :rules="rules" ref="ruleForm"
              :hide-required-asterisk="true"
              style="width: 420px;color:#000000;font-size: 20px;line-height: 20px;"
              >
                <el-form-item label="帳號：" prop="username" :error="errUsername">
                    <el-input type="text" clearable v-model="login.username" placeholder="請輸入手機號碼" style="--el-color-primary:#3AC0CB;height: 40px;width: 360px;"/>
                </el-form-item>
                <el-form-item label="密碼：" prop="psw" :error="errPsw" >
                    <el-input type="password" show-password v-model="login.psw" placeholder="請輸入密碼" style="--el-color-primary:#3AC0CB;height: 40px;margin-top: 5px;width: 360px;"/>
                </el-form-item>
                <el-form-item prop="verifyCode">
                  <el-input type="text" clearable v-model="login.verifyCode" style="--el-color-primary:#3AC0CB;height: 40px;width:242px;margin-right: 5px;" placeholder="請輸入驗證碼"/>
                  <div style="float: left;">
                    <el-tooltip content="看不清,請切換" placement="bottom" effect="light">
                      <img v-if="codeUrl!==''" :src="codeUrl" @click="getCode2" alt="" style="width: 73px;height: 40px;"/>
                    </el-tooltip>
                  </div>
                </el-form-item>
                <el-form-item style="width: 100%;height: 40px;" >
                  <el-checkbox v-model="remLogin" style="--el-color-primary:#3AC0CB;">記住登入資訊</el-checkbox>
                </el-form-item>
                <el-button :disabled="disabledStatus" :style="{'background-color': !disabledStatus?'#3AC0CB':'#B0E6EA'}"  style="width: 100%;--el-color-primary:#3AC0CB;color:#fff;height: 40px;margin-top: 0px;" plain
                @click="Login('ruleForm')"
                >登入</el-button>
            </el-form>
          </div>
          <div class="login-form" v-else>
            <p style="color:#000000;font-size: 24px;font-weight: bold;margin: 20px 0px 20px 0px;">簡訊驗證</p>
            <span style="color:#000000;font-size: 14px;margin: -10px 0px 20px 0px;">簡訊驗證碼已發送，完成驗證即可登入</span>
            <el-form
              label-position="right"
              label-width="100px"
              :model="loginCode"
              :hide-required-asterisk="true"
              :rules="rules" ref="ruleForm2"
              style="width: 420px;color:#000000;font-size: 20px;"
              >
                <el-form-item label="手機號碼："  prop="username">
                    <el-input readonly v-model="loginCode.username" type="text"  style="--el-color-primary:#3AC0CB;height: 40px;width: 360px;"/>
                </el-form-item>
                <el-form-item label="驗證碼："  prop="code" :error="errCode">
                    <el-input type="text" v-model="loginCode.code" style="--el-color-primary:#3AC0CB;height: 40px;width:242px;margin-right: 5px;" placeholder="請輸入簡訊驗證碼" @input="inputcode"/>
                    <el-button :disabled="codeStatus" :style="{'background-color': codeStatus?'#FFE1BF':'#FFC380'}"  style="--el-color-primary:#3AC0CB;height: 40px;width:73px;color:#fff;border-color: #FFE1BF;" @click="sendSms">{{ codeStatus?time+'s':'發送' }}</el-button>
                </el-form-item>
                <el-form-item  :style="{'visibility':yzmtime!==null?'':'hidden'}" style="height: 20px;">
                  <div v-if="yzmtime>0" class="warning">
                    <img src="../assets/images/warningB.png" alt="" style="width: 16px;"> <p class="yzmtime" >本日驗證碼發送次數剩餘：{{ yzmtime }}次</p>
                  </div>
                  <div v-if="yzmtime===0" class="warning">
                    <img src="../assets/images/warningR.png" alt="" style="width: 16px;"> <p class="yzmtime" style="color:#EB5757">本日驗證碼發送次數已達上限</p>
                  </div>
                </el-form-item >
                <el-button :disabled="disabledStatusLogin" :style="{'background-color': !disabledStatusLogin?'#3AC0CB':'#B0E6EA'}" style="width: 100%;--el-color-primary:#3AC0CB;color:#fff;height: 40px;margin-top: 20px;" plain
                 @click="LoginCode('ruleForm2')"
                >完成驗證</el-button>
                <el-button style="width: 100%;background-color: #fff;border:0px;--el-color-primary:#3AC0CB;color:#3AC0CB;height: 40px;margin-top: 20px;" plain
                @click="Back">返回</el-button>
            </el-form>
          </div>

          <div style="position: absolute;bottom: 30px;color:#959595">
            <span >版本號：OCTSystemTW-v1.1.0</span>
          </div>
       </div>
       <el-dialog
          v-model="dialogVisible"
          title="提醒"
          width="30%"
          top="40vh"
          style="text-align: left;"
          :before-close="handleClose"
        >
          <span>{{ returnMsg }}</span>
          <template #footer>
            <span class="dialog-footer">
              <el-button class="tipbtn" style="background-color: #FFC380!important;color:#fff!important" @click="dialogVisible = false">我知道了</el-button>
            </span>
          </template>
        </el-dialog>
    </div>
</template>

<script>
import { login, sendSms, loginSms, getImgCode } from '@/api/index.js'
import RSA from '@/utils/RSA.js'
import axios from 'axios'
export default {
  name: 'login',
  data () {
    return {
      codeStatus: false,
      time: 120,
      login: {
        username: '',
        psw: '',
        verifyCode: ''
      },
      loginCode: {
        username: '',
        code: ''
      },
      codeUrl: '',
      uuid: '',
      remLogin: false,
      errUsername: '',
      errPsw: '',
      errCode: '',
      rules: {
        username: [
          { required: true, message: '請輸入賬號', trigger: 'blur' },
          {
            validator: function (rule, value, callback) {
              if (/^\d+$/.test(value)) {
                if (/^[1][2-9]\d{9}$|[0][9]\d{8}$/.test(value) === false) {
                // if (/^[0][9]\d{8}/.test(value) === false) {
                  callback(new Error('請輸入正確的手機號碼'))
                  // callback(new Error('台灣手機碼(09開頭,10位數字)'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        psw: [
          { required: true, message: '請輸入密碼', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '請輸入簡訊驗證碼', trigger: 'blur' },
          {
            pattern: /^\d{6}$/,
            message: '請輸入6位數簡訊驗證碼',
            trigger: 'blur'
          }
        ]
      },
      loginStatus: false,
      dialogVisible: false,
      returnMsg: '',
      yzmtime: null,
      ipAddressValue: null /// ip地址
    }
  },
  watch: {
    remLogin (newval, oldval) {
      if (newval) {
        localStorage.setItem('loginStatus', JSON.stringify(this.login))
      } else {
        localStorage.deleteItem('loginStatus')
      }
    }
  },
  computed: {
    imgCodeStatus () {
      // const valid = /^[0][9]\d{8}/.test(this.login.username)
      const valid = /^[1][2-9]\d{9}$|[0][9]\d{8}$/.test(this.login.username)
      if (this.login.username && this.login.psw && valid) {
        return false
      } else {
        return true
      }
    },
    disabledStatus () {
      // const valid = /^[0][9]\d{8}/.test(this.login.username)
      const valid = /^[1][2-9]\d{9}$|[0][9]\d{8}$/.test(this.login.username)
      if (this.login.username && this.login.psw && valid && this.login.verifyCode) {
        return false
      } else {
        return true
      }
    },
    disabledStatusLogin () {
      const valid = /^\d{6}$/.test(this.loginCode.code)
      if (this.loginCode.username && valid) {
        return false
      } else {
        return true
      }
    },
    areaCode () {
      const valid = /^[1][2-9]\d{9}/.test(this.login.username)
      const valid2 = /^[0][9]\d{8}/.test(this.login.username)
      if (valid) {
        return true
      } else if (valid2) {
        return false
      } else {
        return false
      }
    }

  },
  mounted () {
    // this.getIpAddress()
    this.formatDate2()
    const loginMessage = localStorage.getItem('loginStatus')
    if (loginMessage && JSON.parse(loginMessage).username) {
      this.login = JSON.parse(loginMessage)
    }
    this.getCode2()
  },
  methods: {///计算默认时间，代替IP功能，有效期一天
    formatDate2() {
        let date = new Date();
        let year = date.getFullYear(); // 年
        let month = date.getMonth() + 1; // 月
        let day = date.getDate(); // 日
        let week = date.getDay(); // 星期
        let weekArr =[
            "星期日",
            "星期一",
            "星期二",
            "星期三",
            "星期四",
            "星期五",
            "星期六",
        ]
        let hour = date.getHours(); // 时
        hour = hour < 10 ? hour : hour; // 如果只有一位，则前面补零
        let minute = date.getMinutes(); // 分
        minute = minute < 10 ? minute : minute; // 如果只有一位，则前面补零
        let second = date.getSeconds(); // 秒
        second = second < 10 ? second : second; // 如果只有一位，则前面补零
        this.ipAddressValue =
            `${year}` +
            "." +
            `${month}` +
            "." +
            `${day}`+
            "." +
            `24`;
    }, //end formatDate
    handleClose () {
      this.dialogVisible = false
    },
    Login (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // 發送登錄請求
          const params = {
            password: RSA.rsaPublicData(this.login.psw),
            username: this.login.username,
            mac: this.ipAddressValue,
            verifyCode: this.login.verifyCode,
            uuid: this.uuid

          }
          this.loginCode.username = JSON.parse(JSON.stringify(this.login.username))
          const { code, msg, data } = await login(params)
          if (Number(code) === 200) {
            if (data.isSecondAuto === 1) {
              this.loginStatus = true// 需要發送驗證碼
              this.sendSms()
            } else {
              this.$store.commit('setUser', data)
              this.$message({
                message: '登錄成功！',
                type: 'success'
              })
              this.$router.push('/')
            }
            this.$refs.ruleForm.resetFields()
          } else if (code === 1007) {
            this.errUsername = msg
            this.$message({
              message: msg,
              type: 'error'
            })
          } else if (code === 2003) {
            this.errPsw = msg
            this.$message({
              message: msg,
              type: 'error'
            })
          } else {
            this.$message({
              message: msg,
              type: 'error'
            })
          }
        } else {
          return false
        }
      })
    },
    getIpAddress () {
      axios.get('https://api.ipify.org?format=json')
        .then(response => {
          this.ipAddressValue = response.data.ip
        })
        .catch(error => {
          console.log(error)
        })
    },
    fasong () {
      if (!this.codeStatus && this.time > 0) {
        this.codeStatus = true
        const Inte = setInterval(() => {
          if (this.time <= 1) {
            clearInterval(Inte)
            this.codeStatus = false
          } else {
            this.time--
          }
        }, 1000)
      }
    },
    async sendSms () {
      // this.loginCode.username = this.login.username
      const da = {
        tel: this.loginCode.username,
        // scenceType: null,
        // effectiveTime: null,
        areaCode: this.areaCode ? '+86' : '+886' /// true 内地 false台湾
      }
      const { code, msg, data } = await sendSms(da)
      this.codeStatus = false
      this.time = 120
      this.yzmtime = null
      if (code === 0) {
        this.fasong()
        this.yzmtime = Number(data.restSendTime)
      } else if (code === -1) {
        this.yzmtime = 0
      } else {
        this.errCode = msg
        this.returnMsg = msg
        this.dialogVisible = true
      }
    },
    inputcode () {
      this.yzmtime = null
    },
    Back () {
      this.loginStatus = false
      this.$refs.ruleForm2.resetFields()
      this.dialogVisible = false
      this.getCode2()
    },
    LoginCode (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            username: this.loginCode.username,
            // username: this.loginCode.username,
            verifyCode: this.loginCode.code,
            scenceType: null,
            effectiveTime: null,
            areaCode: this.areaCode ? '+86' : '+886', /// true 内地 false台湾
            mac: this.ipAddressValue
          }
          const { code, msg, data } = await loginSms(params)
          if (Number(code) === 200) {
            if (data.isSecondAuto === 0) {
              this.$store.commit('setUser', data)
              this.$message({
                message: '登錄成功！',
                type: 'success'
              })
              this.$router.push('/')
            }
          } else {
            this.errCode = msg
            this.returnMsg = msg
            this.dialogVisible = true
          }
        } else {
          return false
        }
      })
    },
    async getCode2 () { /// 后台获取验证码
      const headers = {
        responseType: 'blob',
        emulateJSON: true
      }
      const { code, img, uuid } = await getImgCode(headers)
      if (Number(code) === 200) {
        this.codeUrl = img
        this.uuid = uuid
      } else {
        this.$message({
          type: 'error',
          message: '驗證碼獲取失敗'
        })
      }
    }
  }

}
</script>

<style lang="less" scoped>
.login{
    width: 100%;
    height: 100vh;
    position: fixed;
    background-color:#f6f6f6;
    // opacity: 0.1;
    .box{
        background-color: #fff;
        width: 450px;
        // height: 500px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -70%);
        display: flex;
        justify-content: center;
        border: 1px solid #3AC0CB;
        box-shadow: 10px 0 10px 0px #3AC0CB;
        // align-items: center;
    }
    .yzmtime{
      font-size: 14px;
      color: #787878;
      text-align: center;
      margin-left: 5px;
      padding: 0;
    }
    .warning{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 15px;
    }
    .login-box{
        display: flex;
        justify-content: center;
        margin-top: 140px;
        flex-direction: column;
        align-items: center;
    }
    .login-form{
      background-color: #fff;
      border-radius: 5px;
      width: 564px;
      height: 435px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      // padding-top: 40px;
      // padding-bottom: 50px;
    }
    .el-button+.el-button {
    margin-left:0!important;
    }
}
.tipbtn{
  width: 88px;
  --el-color-primary:#FFC380;
  background-color: #FFC380;
  color:#fff;
  height: 40px;
  border: #FFC380;
}
</style>
<style>
 .box .el-form--default.el-form--label-top .el-form-item .el-form-item__label{
            font-size: 20px;
}
</style>
